import React from "react";
import { GetUserPrivilages } from "../../firebase/UserPrivilageProvider";

import { Link } from "react-router-dom";
function DonorReportHome() {
  const privilages = GetUserPrivilages();
  return (
    <>
      <div className="card">
        <div className="justify-content-center d-flex">
          <h1>Donations Report</h1>
        </div>
      </div>

      <div
        className="card border-top-0 rounded-0"
        style={{ position: "inherit" }}
      >
        {privilages.canAccessDMS && (
          <>
            <div className="row mb-3">
              <div className="col-md">Select here to see report's..</div>
            </div>
            <div className="row g-3">
              <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                <div className="list-group-item list-group-item-primary h-100 text-center">
                  <Link className="fw-bold text-decoration-none" to="/donationdaterangereport">
                    Donations Report By Date
                  </Link>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                <div className="list-group-item list-group-item-primary h-100 text-center">
                  <Link className="fw-bold text-decoration-none" to="/alldonordetailreport">
                    All Donor Detail Report
                  </Link>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                <div className="list-group-item list-group-item-primary h-100 text-center">
                  <Link className="fw-bold text-decoration-none" to="/missedcommittmentreport">
                    Missed Committment Report
                  </Link>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                <div className="list-group-item list-group-item-primary h-100 text-center">
                  <Link className="fw-bold text-decoration-none" to="/form10bdreport">
                    Form 10BD Report
                  </Link>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default DonorReportHome;
